import { useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { onGetInitialValuesThunk } from '../../containers/QuoteStepOne/QuoteStepOne.actions'
import { normalizeDate } from '../utils/dates'
import { features } from '../../config/settings/features'

/**
 * Custom hook to check if the current date has reached or surpassed the maxDate.
 *
 * @returns {boolean} - True if the current date is greater than or equal to maxDate, false otherwise.
 */
export const useHasReachedMaxDate = () => {
  const dispatch = useDispatch()
  const { initData } = useSelector(state => state.quoteStepOne)

  const hasReachedMaxDate = useMemo(() => {
    if (!features['services.use.max.date']) {
      return false
    }

    if (!initData?.maxDate) {
      dispatch(onGetInitialValuesThunk())
      return false
    }

    const currentDate = normalizeDate(new Date())
    const maxDate = normalizeDate(initData.maxDate)

    return currentDate >= maxDate
  }, [initData?.maxDate])

  return hasReachedMaxDate
}
